import React from 'react';

interface DateTimeDisplayProps {
  dateString: string;
  showSeconds?: boolean;
  className?: string;
}

export function DateTimeDisplay({ dateString, showSeconds = false, className = '' }: DateTimeDisplayProps) {
  const formatDateTime = (dateStr: string, includeSeconds: boolean) => {
    const date = new Date(dateStr);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return { formattedDate: 'Invalid Date', formattedTime: '' };
    }

    const dateOptions: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };

    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      ...(includeSeconds && { second: '2-digit' })
    };

    const formattedDate = date.toLocaleDateString('en-US', dateOptions);
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

    return { formattedDate, formattedTime };
  };

  const { formattedDate, formattedTime } = formatDateTime(dateString, showSeconds);

  return (
    <div className={`text-xs ${className}`}>
      <div className="font-medium">{formattedDate}</div>
      <div className="text-gray-500 dark:text-gray-400">{formattedTime}</div>
    </div>
  );
}
